export const getDigitalSavingsState = state => state?.digitalSavings;
